import { baseApi } from 'api/base';
import { fileApi } from 'api/file';

const downloadDpoFileForErul = async (id: string) =>
  baseApi
    .post(`/erul/generate-confirming-document/${id}`, {}, { responseType: 'blob' })
    .then(fileApi.downloadFile);

const downloadFeedFileForErul = async (id: string) =>
  baseApi
    .post(`/erul/generate-feed-additive/${id}`, {}, { responseType: 'blob' })
    .then(fileApi.downloadFile);

const downloadGmpFileForErul = async (id: string) =>
  baseApi.post(`/erul/generate-gmp/${id}`, {}, { responseType: 'blob' }).then(fileApi.downloadFile);

const downloadGmoFileForErul = async (id: string) =>
  baseApi.post(`/erul/generate-gmo/${id}`, {}, { responseType: 'blob' }).then(fileApi.downloadFile);

const downloadGmProductFileForErul = async (id: string) =>
  baseApi
    .post(`/erul/generate-gm-product/${id}`, {}, { responseType: 'blob' })
    .then(fileApi.downloadFile);

const downloadPharmPermissionFileForErul = async (id: string) =>
  baseApi
    .post(`/erul/generate-pharm-permission/${id}`, {}, { responseType: 'blob' })
    .then(fileApi.downloadFile);

const sendDpoToErul = async (id: string) => {
  const res = await baseApi.post(`/erul/send-confirming-document/${id}`);
  return res.data;
};

const sendFeedToErul = async (id: string) => {
  const res = await baseApi.post(`/erul/send-feed-additive/${id}`);
  return res.data;
};

const sendGmpToErul = async (id: string) => {
  const res = await baseApi.post(`/erul/send-gmp/${id}`);
  return res.data;
};

const sendGmoToErul = async (id: string) => {
  const res = await baseApi.post(`/erul/send-gmo/${id}`);
  return res.data;
};

const sendGmProductToErul = async (id: string) => {
  const res = await baseApi.post(`/erul/send-gm-product/${id}`);
  return res.data;
};

const sendPharmPermissionToErul = async (id: string) => {
  const res = await baseApi.post(`/erul/send-pharm-permission/${id}`);
  return res.data;
};

export const erulApi = {
  downloadDpoFileForErul,
  downloadFeedFileForErul,
  downloadGmpFileForErul,
  downloadGmoFileForErul,
  downloadGmProductFileForErul,
  downloadPharmPermissionFileForErul,
  sendDpoToErul,
  sendFeedToErul,
  sendGmpToErul,
  sendGmoToErul,
  sendGmProductToErul,
  sendPharmPermissionToErul,
};
